import React, { SetStateAction, useContext, useEffect } from "react";
import { useState } from "react";
import {
    Box,
    Paper,
    Snackbar,
    Stack,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import {
    CustomSelect,
    CustomTextField,
    CustomThemeProvider,
} from "../../../Styles/theme/customThemeprovider";

import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import {
    StyledTableCellRight,
    StyledTableHead,
} from "../../../Styles/tabelCellStyled/customTableCell";
import BasicPopover from "../../../Components/Popover";
import { Alert } from "../../../Components/Alert/Alert";
import { IPlanoNutrientes } from "../../../Interfaces/anexos/anexo1/plano_nutrientes1_3";
import { calcario } from "../../../informacao_estatica";
import { ICabecalho } from "../../../Interfaces/anexos/anexo1/analise_e_foliar1_1_3";
import { get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";



interface ComposicaoQ1Form_prop {
    obj_anexo_cabecalho_selecionado: ICabecalho | undefined;
    obj_da_tabela_3_atualizado: IPlanoNutrientes | undefined;
    set_obj_da_tabela_3_atualizado: React.Dispatch<SetStateAction<IPlanoNutrientes | undefined>>;

}


export const PlanoNutrientesForm: React.FC<ComposicaoQ1Form_prop> = ({ obj_anexo_cabecalho_selecionado, obj_da_tabela_3_atualizado, set_obj_da_tabela_3_atualizado }) => {
    const auth = useContext(AuthContext);
    const location = useLocation();
    const is_historico = location.state?.is_historico ?? false;

    const [createTable, setCreateTable] = useState(false);
    const [message, setMessage] = useState("");
    const [openSnackSuccess, setOpenSnackSuccess] = useState(false);
    const [openSnackError, setOpenSnackError] = useState(false);
    const [obj_anexo, set_obj_anexo] = useState<IPlanoNutrientes>();
    const [error_previsao_camp5, set_error_previsao_camp5] = useState(false);
    const [error_previsao_camp6, set_error_previsao_camp6] = useState(false);
    const [error_previsao_camp7, set_error_previsao_camp7] = useState(false);
    const [error_previsao_camp8, set_error_previsao_camp8] = useState(false);
    const [base_dados_verificada, set_base_dados_verificada] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [existe_cabecalho, set_existe_cabecalho] = useState(false)


    const [flag_editado, set_flag_editado] = React.useState(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);
    const handleCloseDialog = () => {
        set_obj_anexo(undefined)
        setCreateTable(false);

        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };

    const onInputChange = (event: any) => {
        const { name, value, type, checked } = event.target;
        let aux_obj_anexo: any = obj_anexo === undefined ? {} : obj_anexo
        set_flag_editado(true)

        if (type === "checkbox") {
            aux_obj_anexo[name] = aux_obj_anexo[name] === undefined ? true : !aux_obj_anexo[name]
            set_obj_anexo(aux_obj_anexo);

        } else {


            if (name === 'previsao_camp5') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_previsao_camp5(true)
                } else {
                    set_error_previsao_camp5(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'previsao_camp6') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_previsao_camp6(true)
                } else {
                    set_error_previsao_camp6(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'previsao_camp7') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_previsao_camp7(true)
                } else {
                    set_error_previsao_camp7(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'previsao_camp8') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_previsao_camp8(true)
                } else {
                    set_error_previsao_camp8(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else {
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: value,
                }));

            }


        }


    };



    const handleCloseSnack = () => {

        setOpenSnackSuccess(false);
        setOpenSnackError(false);
    };

    const get_info = async () => {
        try {
            let res = await get(auth.token.cookie_token,
                `/get_reg_anexo_um_plano_nutri_cabecalho/${obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho}`
            );

            if (res.status === 200) {
                if (res.data.result.length !== 0) {
                    set_obj_da_tabela_3_atualizado(res.data.result[0]);
                } else {
                    setCreateTable(true)
                }
            } else {
                setMessage("Erro a carregar informação!");
                setOpenSnackError(true);
            }

            set_base_dados_verificada(true)
            set_existe_cabecalho(true)

            setIsLoading(false);
        } catch (error) {
            func_print("get_info", error, true);
            setMessage("Erro!");

            setOpenSnackError(true);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        (async () => {
            if (obj_anexo_cabecalho_selecionado !== undefined) {

                if (obj_da_tabela_3_atualizado === undefined && base_dados_verificada === false) {
                    await get_info();
                }
            } else {
                set_existe_cabecalho(false)
                set_base_dados_verificada(false)
                set_obj_da_tabela_3_atualizado(undefined)
            }
        })();
    }, [obj_anexo_cabecalho_selecionado]);

    const handle_criar_anexo = async () => {
        if (error_previsao_camp5 || error_previsao_camp6 || error_previsao_camp7 || error_previsao_camp8) {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } else {

            try {
                setIsLoading(true);

                let data = await post(auth.token.cookie_token, "new_reg_anexo_um_plano_nutri", {
                    payload: {

                        id_plano: 0,
                        elemento_camp1: obj_anexo?.elemento_camp1 === undefined ? '' : obj_anexo?.elemento_camp1,
                        elemento_camp2: obj_anexo?.elemento_camp2 === undefined ? '' : obj_anexo?.elemento_camp2,
                        elemento_camp3: obj_anexo?.elemento_camp3 === undefined ? '' : obj_anexo?.elemento_camp3,
                        previsao_camp1: obj_anexo?.previsao_camp1 === undefined ? '' : obj_anexo?.previsao_camp1,
                        previsao_camp2: obj_anexo?.previsao_camp2 === undefined ? '' : obj_anexo?.previsao_camp2,
                        previsao_camp3: obj_anexo?.previsao_camp3 === undefined ? '' : obj_anexo?.previsao_camp3,
                        previsao_camp4: obj_anexo?.previsao_camp4 === undefined ? '' : obj_anexo?.previsao_camp4,
                        previsao_camp5: obj_anexo?.previsao_camp5 === undefined ? '' : obj_anexo?.previsao_camp5,
                        previsao_camp6: obj_anexo?.previsao_camp6 === undefined ? '' : obj_anexo?.previsao_camp6,
                        previsao_camp7: obj_anexo?.previsao_camp7 === undefined ? '' : obj_anexo?.previsao_camp7,
                        previsao_camp8: obj_anexo?.previsao_camp8 === undefined ? '' : obj_anexo?.previsao_camp8,
                        indentifica: obj_anexo?.indentifica === undefined ? '' : obj_anexo?.indentifica,
                        id_anexo_um_cabecalho: obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho,
                        last_update: new Date().toISOString(),
                        create_date: new Date().toISOString(),
                        uuid: ""
                    }
                })
                if (data.status === 200) {
                    setMessage("Operação efetuada com sucesso!");
                    setOpenSnackSuccess(true);
                    set_flag_editado(false)

                    set_obj_da_tabela_3_atualizado(data.data.result)
                    set_obj_anexo(undefined)
                    setCreateTable(false)
                    set_existe_cabecalho(true)
                } else {
                    setMessage("Erro ao efetuar a sua operação!");
                    setOpenSnackError(true);
                }
                setIsLoading(false);

            } catch (error) {
                func_print('handle_criar_anexo', error, true)
                setIsLoading(false);

                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
            }
        }
    }

    const handle_update_anexo = async () => {
        if (error_previsao_camp5 || error_previsao_camp6 || error_previsao_camp7 || error_previsao_camp8) {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } else {

            try {
                setIsLoading(true);
                let res = await post(auth.token.cookie_token, "update_reg_anexo_um_plano_nutri", { payload: obj_anexo });

                if (res.status === 200) {

                    set_obj_anexo(undefined);
                    setCreateTable(false)
                    set_obj_da_tabela_3_atualizado(res.data.result)
                    set_flag_editado(false)

                    setMessage("Gravado com sucesso!");
                    setOpenSnackSuccess(true);
                } else {
                    setMessage("Erro ao gravar!");

                    setOpenSnackError(true);
                }

                setIsLoading(false);
            } catch (error) {
                func_print("handle_update_anexo", error, true);
                setMessage("Erro ao gravar!");

                setOpenSnackError(true);
                setIsLoading(false);
            }
        }

    };

    return (
        <>
            <CustomThemeProvider>
                <TableContainer
                    component={Paper}
                    variant="outlined"
                    sx={{
                        height: "auto",
                        width: "auto",
                        margin: 2,
                        padding: 2,
                    }}
                >
                    <Snackbar
                        open={openSnackSuccess}
                        autoHideDuration={2000}
                        onClose={handleCloseSnack}
                    >
                        <Alert
                            onClose={handleCloseSnack}
                            severity="success"
                            sx={{ width: "100%" }}
                        >
                            {message}
                        </Alert>
                    </Snackbar>
                    <Snackbar
                        open={openSnackError}
                        autoHideDuration={2000}
                        onClose={handleCloseSnack}
                    >
                        <Alert
                            onClose={handleCloseSnack}
                            severity="error"
                            sx={{ width: "100%" }}
                        >
                            {message}

                        </Alert>
                    </Snackbar>

                    <table style={{ width: "100%" }}>
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    colSpan={8}
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: 18,
                                        textAlign: "left",
                                        fontFamily: "candara",
                                    }}
                                >
                                    3 - Plano de aplicação de nutrientes a disponibilizar à cultura
                                </TableCell>
                                {createTable === false ?
                                    <TableCell>
                                        <Stack direction="row" justifyContent="end">
                                            {
                                                base_dados_verificada === true && existe_cabecalho === true ?
                                                    obj_da_tabela_3_atualizado !== undefined ?
                                                        is_historico === true ? <></> :

                                                            <ButtonCadernos
                                                                mostrarBotaoEditar
                                                                aoClicarEditar={() => {
                                                                    set_obj_anexo(obj_da_tabela_3_atualizado)
                                                                    setCreateTable(true)
                                                                }}

                                                            />

                                                        :
                                                        is_historico === true ? <></> :

                                                            <ButtonCadernos
                                                                mostrarBotaoNovo
                                                                aoClicarNovo={() => setCreateTable(true)}
                                                            />

                                                    :
                                                    <></>
                                            }

                                        </Stack>
                                    </TableCell>
                                    :
                                    <TableCell>
                                        <ButtonCadernos
                                            mostrarBotaoCancelar={obj_da_tabela_3_atualizado !== undefined}
                                            aoClicarCancelar={() => {
                                                if (flag_editado) {
                                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)

                                                } else {

                                                    set_obj_anexo(undefined);
                                                    setCreateTable(false);
                                                }

                                            }}
                                            mostrarBotaoGravar
                                            aoClicarGravar={() => {

                                                obj_da_tabela_3_atualizado === undefined ?

                                                    handle_criar_anexo()

                                                    :
                                                    handle_update_anexo()


                                            }}
                                        />
                                    </TableCell>

                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {createTable === false ?
                                <>
                                    <TableRow>
                                        <StyledTableHead>Nutrientes</StyledTableHead>
                                        <StyledTableHead width="8%">
                                            <Stack direction="row" justifyContent="center">
                                                N (kg/ha)
                                                <BasicPopover
                                                    text={
                                                        "Valores devem ser expressos em kg/ha.\nTer em atenção que:\n- De acordo com o Regulamento 2018/848, em Agricultura Biológica, a quantidade total de estrume animal a aplicar não pode exceder 170 kg de azoto por ano e por hectare;\n\n- Nas parcelas em Zona Vulnerável, de acordo com a Portaria n.º259/2012, a quantidade de matérias fertilizantes de natureza orgânica a aplicar, por hectare de SAU e ano, não pode veicular mais de 250 kg de azoto total, o qual não deve conter mais de 170 kg de azoto total de efluentes pecuários."
                                                    }
                                                />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead width="8%">
                                            <Stack direction="row" justifyContent="center">
                                                P2O5 (kg/ha)
                                                <BasicPopover
                                                    text={"Valores devem ser expressos em kg/ha."}
                                                />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead width="8%">
                                            <Stack direction="row" justifyContent="center">
                                                K2O (kg/ha)
                                                <BasicPopover
                                                    text={"Valores devem ser expressos em kg/ha."}
                                                />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead width="8%">
                                            <Stack direction="row" justifyContent="center">
                                                Mg (kg/ha)
                                                <BasicPopover
                                                    text={"Valores devem ser expressos em kg/ha."}
                                                />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead width="8%">
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "right",
                                                }}
                                            >
                                                Calagem (kg/ha)
                                                <BasicPopover
                                                    text={
                                                        "Preencher apenas quando for recomendada a calagem.\n\nValores devem ser expressos em kg/ha."
                                                    }
                                                />
                                            </Box>
                                        </StyledTableHead>
                                        <StyledTableHead width="8%">
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "right",
                                                }}
                                            >
                                                {obj_da_tabela_3_atualizado?.elemento_camp1 === undefined ? '' : obj_da_tabela_3_atualizado?.elemento_camp1}

                                                <BasicPopover
                                                    text={
                                                        "Preencher apenas quando se prevê aplicar um elemento nutricional adicional.\n\nValores devem ser expressos em kg/ha."
                                                    }
                                                />
                                            </Box>
                                        </StyledTableHead>
                                        <StyledTableHead width="8%">
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "right",
                                                }}
                                            >
                                                {obj_da_tabela_3_atualizado?.elemento_camp2 === undefined ? '' : obj_da_tabela_3_atualizado?.elemento_camp2}

                                                <BasicPopover
                                                    text={
                                                        "Preencher apenas quando se prevê aplicar um elemento nutricional adicional.\n\nValores devem ser expressos em kg/ha."
                                                    }
                                                />
                                            </Box>
                                        </StyledTableHead>
                                        <StyledTableHead width="8%">
                                            <Stack direction="row" justifyContent="right">
                                                {obj_da_tabela_3_atualizado?.elemento_camp3 === undefined ? '' : obj_da_tabela_3_atualizado?.elemento_camp3}

                                                <BasicPopover
                                                    text={
                                                        "Preencher apenas quando se prevê aplicar um elemento nutricional adicional.\n\nValores devem ser expressos em kg/ha."
                                                    }
                                                />
                                            </Stack>
                                        </StyledTableHead>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableHead>
                                            Previsão total de nutrientes a disponibilizar à cultura
                                        </StyledTableHead>
                                        <StyledTableCellRight>
                                            {obj_da_tabela_3_atualizado?.previsao_camp1 === undefined ? '' : obj_da_tabela_3_atualizado?.previsao_camp1.toString().replace('.', ',')}

                                            <BasicPopover
                                                text={
                                                    "Auxiliar - fórmula de cálculo:\n\nN=Nc-(Ns-Na-Nv-Nr-Nx)\n\nN - Total de azoto a disponibilizar à cultura;\nNc - Necessidade da cultura em azoto;\nNs - Quantidade de azoto a deduzir em função dos resultados das análises de terras;\nNa - Azoto veículado pela água de rega;\nNv - Azoto proveniente da adubação verde;\nNr - Azoto proveniente dos resíduos da cultura precedente;\nNx - Azoto proveniente do excreta dos animais em pastoreio."
                                                }
                                            />

                                        </StyledTableCellRight>
                                        <StyledTableCellRight>
                                            {obj_da_tabela_3_atualizado?.previsao_camp2 === undefined ? '' : obj_da_tabela_3_atualizado?.previsao_camp2.toString().replace('.', ',')}

                                            <BasicPopover
                                                text={
                                                    "Auxiliar - fórmula de cálculo:\n\nP2O5=Pc-(Pa-Pv-Px)\n\nP2O5 - Total de fósforo a disponibilizar à cultura;\nPc - Necessidade da cultura em fósforo;\nPa - Fósforo veículado pela água de rega;\nPv - Fósforo proveniente da adubação verde;\nNx - Fósforo proveniente do excreta dos animais em pastoreio."
                                                }
                                            />
                                        </StyledTableCellRight>
                                        <StyledTableCellRight>
                                            {obj_da_tabela_3_atualizado?.previsao_camp3 === undefined ? '' : obj_da_tabela_3_atualizado?.previsao_camp3.toString().replace('.', ',')}

                                            <BasicPopover
                                                text={
                                                    "Auxiliar - fórmula de cálculo:\n\nK2O=Kc-(Kv-Kx)\n\nK2O - Total de potássio a disponibilizar à cultura;\nKc - Necessidade da cultura em potássio;\nKv - Potássio proveniente da adubação verde;\nKx - Potássio proveniente do excreta dos animais em pastoreio."
                                                }
                                            />
                                        </StyledTableCellRight>
                                        <StyledTableCellRight>
                                            {obj_da_tabela_3_atualizado?.previsao_camp4 === undefined ? '' : obj_da_tabela_3_atualizado?.previsao_camp4.toString().replace('.', ',')}

                                            <BasicPopover
                                                text={
                                                    "Auxiliar - fórmula de cálculo:\n\nMg=Mgc-(Mgv)\n\nMg - Total de magnésio a disponibilizar à cultura;\nMgc - Necessidade da cultura em magnésio;\nMgv - Magnésio proveniente da adubação verde.\n\nNota: Quando há aplicação de calcários magnesianos ou dolomíticos, que contêm magnésio, considerar a quantidade de Mg veiculada pelo calcário."
                                                }
                                            />
                                        </StyledTableCellRight>
                                        <StyledTableCellRight>
                                            {obj_da_tabela_3_atualizado?.previsao_camp5 === undefined ? '' : obj_da_tabela_3_atualizado?.previsao_camp5.toString().replace('.', ',')}

                                            <BasicPopover
                                                text={
                                                    "Indicar a quantidade de calcário recomendada em kg/ha"
                                                }
                                            />
                                        </StyledTableCellRight>
                                        <StyledTableCellRight>
                                            {obj_da_tabela_3_atualizado?.previsao_camp6 === undefined ? '' : obj_da_tabela_3_atualizado?.previsao_camp6.toString().replace('.', ',')}

                                            <BasicPopover
                                                text={
                                                    "Preencher manualmente com os valores da quantidade de nutriente adicional a aplicar (caso exista)."
                                                }
                                            />
                                        </StyledTableCellRight>
                                        <StyledTableCellRight>
                                            {obj_da_tabela_3_atualizado?.previsao_camp7 === undefined ? '' : obj_da_tabela_3_atualizado?.previsao_camp7.toString().replace('.', ',')}

                                            <BasicPopover
                                                text={
                                                    "Preencher apenas quando se prevê aplicar um elemento nutricional adicional.\n\nValores devem ser expressos em kg/ha."
                                                }
                                            />
                                        </StyledTableCellRight>
                                        <StyledTableCellRight>
                                            {obj_da_tabela_3_atualizado?.previsao_camp8 === undefined ? '' : obj_da_tabela_3_atualizado?.previsao_camp8.toString().replace('.', ',')}

                                            <BasicPopover
                                                text={
                                                    "Preencher apenas quando se prevê aplicar um elemento nutricional adicional.\n\nValores devem ser expressos em kg/ha."
                                                }
                                            />
                                        </StyledTableCellRight>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell
                                            colSpan={3}
                                            sx={{ fontWeight: 600, fontFamily: "candara" }}
                                        >
                                            <Stack
                                                direction="row"
                                                justifyContent="right"
                                                alignItems="center"
                                            >
                                                Identificar o tipo de calcário aplicado:
                                                <BasicPopover
                                                    text={
                                                        "Sempre que for efetuado a correção do pH do solo por calagem é obrigatória indicar o teor de magnésio do calcário (em Mg ou MgO).\n\nValores possíveis:\n- Calcário calcítico (constituído apenas por carbonato de cálcio);\n- Calcário magnesiano (teor de óxido de magnésio igual ou superior a 3%);\n- Calcário dolomítico (constituídos por carbonato de cálcio e carbonato de magnésio, mas com teor de óxido de magnésio igual ou superior a 12 %)."
                                                    }
                                                />
                                            </Stack>
                                        </TableCell>
                                        <TableCell colSpan={6}>{obj_da_tabela_3_atualizado?.indentifica === undefined ? '' : obj_da_tabela_3_atualizado?.indentifica}</TableCell>
                                    </TableRow>

                                </>
                                :
                                <>
                                    <TableRow>
                                        <StyledTableHead>Nutrientes</StyledTableHead>
                                        <StyledTableHead width="8%">
                                            <Stack direction="row" justifyContent="center">
                                                N (kg/ha)
                                                <BasicPopover
                                                    text={
                                                        "Valores devem ser expressos em kg/ha.\nTer em atenção que:\n- De acordo com o Regulamento 2018/848, em Agricultura Biológica, a quantidade total de estrume animal a aplicar não pode exceder 170 kg de azoto por ano e por hectare;\n\n- Nas parcelas em Zona Vulnerável, de acordo com a Portaria n.º259/2012, a quantidade de matérias fertilizantes de natureza orgânica a aplicar, por hectare de SAU e ano, não pode veicular mais de 250 kg de azoto total, o qual não deve conter mais de 170 kg de azoto total de efluentes pecuários."
                                                    }
                                                />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead width="8%">
                                            <Stack direction="row" justifyContent="center">
                                                P2O5 (kg/ha)
                                                <BasicPopover
                                                    text={"Valores devem ser expressos em kg/ha."}
                                                />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead width="8%">
                                            <Stack direction="row" justifyContent="center">
                                                K2O (kg/ha)
                                                <BasicPopover
                                                    text={"Valores devem ser expressos em kg/ha."}
                                                />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead width="8%">
                                            <Stack direction="row" justifyContent="center">
                                                Mg (kg/ha)
                                                <BasicPopover
                                                    text={"Valores devem ser expressos em kg/ha."}
                                                />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead width="8%">
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "right",
                                                }}
                                            >
                                                Calagem (kg/ha)
                                                <BasicPopover
                                                    text={
                                                        "Preencher apenas quando for recomendada a calagem.\n\nValores devem ser expressos em kg/ha."
                                                    }
                                                />
                                            </Box>
                                        </StyledTableHead>
                                        <StyledTableHead width="8%">
                                            <CustomTextField
                                                name="elemento_camp1"
                                                value={obj_anexo?.elemento_camp1 === undefined ? '' : obj_anexo?.elemento_camp1}
                                                onChange={onInputChange}
                                            />
                                        </StyledTableHead>
                                        <StyledTableHead width="8%">
                                            <CustomTextField
                                                name="elemento_camp2"
                                                value={obj_anexo?.elemento_camp2 === undefined ? '' : obj_anexo?.elemento_camp2}
                                                onChange={onInputChange}
                                            />
                                        </StyledTableHead>
                                        <StyledTableHead width="8%">
                                            <CustomTextField
                                                name="elemento_camp3"
                                                value={obj_anexo?.elemento_camp3 === undefined ? '' : obj_anexo?.elemento_camp3}
                                                onChange={onInputChange}
                                            />
                                        </StyledTableHead>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableHead>
                                            Previsão total de nutrientes a disponibilizar à cultura
                                        </StyledTableHead>
                                        <StyledTableCellRight>
                                            {obj_anexo?.previsao_camp1 === undefined ? '' : obj_anexo?.previsao_camp1.toString().replace('.', ',')}

                                        </StyledTableCellRight>
                                        <StyledTableCellRight>
                                            {obj_anexo?.previsao_camp2 === undefined ? '' : obj_anexo?.previsao_camp2.toString().replace('.', ',')}


                                        </StyledTableCellRight>
                                        <StyledTableCellRight>
                                            {obj_anexo?.previsao_camp3 === undefined ? '' : obj_anexo?.previsao_camp3.toString().replace('.', ',')}

                                        </StyledTableCellRight>
                                        <StyledTableCellRight>
                                            {obj_anexo?.previsao_camp4 === undefined ? '' : obj_anexo?.previsao_camp4.toString().replace('.', ',')}

                                        </StyledTableCellRight>

                                        <StyledTableCellRight>
                                            <CustomTextField
                                                name="previsao_camp5"
                                                value={obj_anexo?.previsao_camp5 === undefined ? '' : obj_anexo?.previsao_camp5.toString().replace('.', ',')}
                                                onChange={onInputChange}
                                                error={error_previsao_camp5}
                                                helperText={error_previsao_camp5 ? "Apenas números são aceites" : ""}
                                            />
                                        </StyledTableCellRight>
                                        <StyledTableCellRight>
                                            <CustomTextField
                                                name="previsao_camp6"
                                                value={obj_anexo?.previsao_camp6 === undefined ? '' : obj_anexo?.previsao_camp6.toString().replace('.', ',')}
                                                onChange={onInputChange}
                                                error={error_previsao_camp6}
                                                helperText={error_previsao_camp6 ? "Apenas números são aceites" : ""}
                                            />
                                        </StyledTableCellRight>
                                        <StyledTableCellRight>
                                            <CustomTextField
                                                name="previsao_camp7"
                                                value={obj_anexo?.previsao_camp7 === undefined ? '' : obj_anexo?.previsao_camp7.toString().replace('.', ',')}
                                                onChange={onInputChange}
                                                error={error_previsao_camp7}
                                                helperText={error_previsao_camp7 ? "Apenas números são aceites" : ""}
                                            />
                                        </StyledTableCellRight>
                                        <StyledTableCellRight>
                                            <CustomTextField
                                                name="previsao_camp8"
                                                value={obj_anexo?.previsao_camp8 === undefined ? '' : obj_anexo?.previsao_camp8.toString().replace('.', ',')}
                                                onChange={onInputChange}
                                                error={error_previsao_camp8}
                                                helperText={error_previsao_camp8 ? "Apenas números são aceites" : ""}
                                            />
                                        </StyledTableCellRight>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell
                                            colSpan={3}
                                            sx={{ fontWeight: 600, fontFamily: "candara" }}
                                        >
                                            <Stack
                                                direction="row"
                                                justifyContent="right"
                                                alignItems="center"
                                            >
                                                Identificar o tipo de calcário aplicado:
                                                <BasicPopover
                                                    text={
                                                        "Sempre que for efetuado a correção do pH do solo por calagem é obrigatória indicar o teor de magnésio do calcário (em Mg ou MgO).\n\nValores possíveis:\n- Calcário calcítico (constituído apenas por carbonato de cálcio);\n- Calcário magnesiano (teor de óxido de magnésio igual ou superior a 3%);\n- Calcário dolomítico (constituídos por carbonato de cálcio e carbonato de magnésio, mas com teor de óxido de magnésio igual ou superior a 12 %)."
                                                    }
                                                />
                                            </Stack>
                                        </TableCell>
                                        <TableCell colSpan={6}>
                                            <CustomSelect
                                                value={obj_anexo?.indentifica === undefined ? '' : obj_anexo?.indentifica}
                                                name="indentifica"
                                                onChange={onInputChange}
                                                options={calcario}
                                                label="Origem dos Nutrientes"
                                            />
                                        </TableCell>
                                    </TableRow>
                                </>
                            }


                        </TableBody>
                    </table>
                    <ConfirmDialog
                        open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                        onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                        onConfirm={() => handleCloseDialog()}
                        message={mensagem_tem_a_certeza_de_apagar_alteracoes}
                    />
                </TableContainer>
            </CustomThemeProvider>
        </>
    );
};